export const environment = {
  production: false,
  version: '0.0.1-dev',
  sessionCryptoKey: 'sdx-s-stock-dev-key-replace-me',
  productBackendEndpoint: 'https://api-easypay-dev.softdirex.com/v1',
  bffEndpoint: 'https://api-sstock-dev.softdirex.com',
  bffProductId: 4,
  sessionIdleMinutes: 5,
  sessionIdleWarningSeconds: 60,
  downloadUrl: 'https://play.google.com/store/apps/details?id=com.softdirex.sstock',
  whatsappNumber: '56939056553',
};
